import React from 'react';
import { Facebook, Instagram, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-white pt-16 pb-8 border-t border-white/10" data-id="element-15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-17">
          {/* Brand */}
          <div data-id="element-18">
            <a href="#" className="text-2xl font-bold tracking-tighter text-white uppercase block mb-6" data-id="element-19">
              Eurosport <span className="text-[#c41e3a]" data-id="element-20">Auto Care</span>
            </a>
            <p className="text-gray-500 mb-6 leading-relaxed" data-id="element-21">
              Premier automotive care for European and exotic vehicles in
              Davidsonville, Maryland. Experience the difference of true
              craftsmanship.
            </p>
            <div className="flex space-x-4" data-id="element-22">
              <a href="#" className="text-gray-400 hover:text-[#c41e3a] transition-colors" data-id="element-23">
                <Facebook size={20} data-id="element-24" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#c41e3a] transition-colors" data-id="element-25">
                <Instagram size={20} data-id="element-26" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#c41e3a] transition-colors" data-id="element-27">
                <Twitter size={20} data-id="element-28" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-29">
            <h3 className="text-lg font-bold uppercase tracking-wider mb-6" data-id="element-30">
              Quick Links
            </h3>
            <ul className="space-y-4" data-id="element-31">
              <li data-id="element-32">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-33">
                  Services
                </a>
              </li>
              <li data-id="element-34">
                <a href="#brands" className="text-gray-400 hover:text-white transition-colors" data-id="element-35">
                  Brands We Service
                </a>
              </li>
              <li data-id="element-36">
                <a href="#gallery" className="text-gray-400 hover:text-white transition-colors" data-id="element-37">
                  Gallery
                </a>
              </li>
              <li data-id="element-38">
                <a href="#why-us" className="text-gray-400 hover:text-white transition-colors" data-id="element-39">
                  About Us
                </a>
              </li>
              <li data-id="element-40">
                <a href="#location" className="text-gray-400 hover:text-white transition-colors" data-id="element-41">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-42">
            <h3 className="text-lg font-bold uppercase tracking-wider mb-6" data-id="element-43">
              Services
            </h3>
            <ul className="space-y-4" data-id="element-44">
              <li className="text-gray-400" data-id="element-45">Oil & Fluid Service</li>
              <li className="text-gray-400" data-id="element-46">Brake Repair</li>
              <li className="text-gray-400" data-id="element-47">Engine Diagnostics</li>
              <li className="text-gray-400" data-id="element-48">Transmission Repair</li>
              <li className="text-gray-400" data-id="element-49">Performance Tuning</li>
            </ul>
          </div>

          {/* CTA */}
          <div data-id="element-50">
            <h3 className="text-lg font-bold uppercase tracking-wider mb-6" data-id="element-51">
              Book Appointment
            </h3>
            <p className="text-gray-500 mb-6" data-id="element-52">
              Ready to give your vehicle the care it deserves? Contact us today.
            </p>
            <a href="tel:4107980900" className="inline-block w-full text-center px-6 py-3 bg-[#c41e3a] text-white font-bold uppercase tracking-wider hover:bg-[#a01830] transition-colors rounded-sm" data-id="element-53">
              Schedule Service
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-600 text-sm" data-id="element-54">
          <p data-id="element-55">
            &copy; {new Date().getFullYear()} Eurosport Auto Care. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-56">
            <a href="#" className="hover:text-gray-400" data-id="element-57">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-400" data-id="element-58">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}